import React from 'react';
import styled from 'styled-components';

import HistoryPrintingListingWeek from './HistoryPrintingListingWeek';
import type { MonthData } from '../../domain/History';

const MonthCell = styled.td`
  ${({ theme }) => `
    font-weight: ${theme.fonts.weights.bolder};
    font-size: ${theme.fonts.style.midSmall.fontSize}px;
    column-span: all;
  `}
`;

const Underline = styled.div`
  ${({ theme }) => `
    margin-top: ${theme.metrics.tinyMargin}px;
    border-top: 2px solid ${theme.colors.primary}; 
  `}
`;

const MonthWrapper = styled.div`
  display: inline-block;
`;

type Props = {
  month: MonthData;
}

export function HistoryPrintingListingMonth({ month }: Props) {
  return (
    <React.Fragment>
      <tr id={month.month}>
        <MonthCell>
          <MonthWrapper>
            {month.month}
            <Underline />
          </MonthWrapper>
        </MonthCell>
      </tr>
      {month.weeks.map(week => <HistoryPrintingListingWeek week={week} key={`${week.from}${week.to}`} />)}
    </React.Fragment>
  );
}

export default HistoryPrintingListingMonth;



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/printing/components/HistoryPrintingListingMonth.js